export default __webpack_public_path__ + "static/media/extension-activation-bg.876a6d09.svg";